import { render } from "./SpecialMainHeader.vue?vue&type=template&id=4515a68b"
import script from "./SpecialMainHeader.vue?vue&type=script&lang=js"
export * from "./SpecialMainHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__